<template>
  <b-dropdown
    aria-role="list"
    position="is-bottom-left"
    :triggers="['hover']"
    :delay="300"
  >
    <template #trigger>
      <button-tooltip
        tooltip="Example Types"
        position="is-bottom"
        :label="scenarioTypeLabel"
        type="is-info is-light"
        size="is-small"
        outlined
      />
    </template>

    <b-dropdown-item
      aria-role="listitem"
      class="dropdown-item-with-icon"
      @click="toggleFilter('examples')"
    >
      <span class="icon-wrapper">📝</span>
      Examples ({{ examplesCount }})
      <b-icon
        v-if="activeCategories.includes('examples')"
        icon="check"
        class="has-text-success ml-auto"
      />
    </b-dropdown-item>

    <b-dropdown-item
      aria-role="listitem"
      class="dropdown-item-with-icon"
      @click="toggleFilter('puzzles')"
    >
      <span class="icon-wrapper">🧩</span>
      Puzzles ({{ puzzlesCount }})
      <b-icon
        v-if="activeCategories.includes('puzzles')"
        icon="check"
        class="has-text-success ml-auto"
      />
    </b-dropdown-item>

    <b-dropdown-item
      aria-role="listitem"
      class="dropdown-item-with-icon"
      @click="toggleFilter('classwork')"
    >
      <span class="icon-wrapper">📖</span>
      Classwork ({{ classworkCount }})
      <b-icon
        v-if="activeCategories.includes('classwork')"
        icon="check"
        class="has-text-success ml-auto"
      />
    </b-dropdown-item>

    <b-dropdown-item
      aria-role="listitem"
      class="dropdown-item-with-icon"
      @click="toggleFilter('homework')"
    >
      <span class="icon-wrapper">📚</span>
      Homework ({{ homeworkCount }})
      <b-icon
        v-if="activeCategories.includes('homework')"
        icon="check"
        class="has-text-success ml-auto"
      />
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import ButtonTooltip from "@/components/ui/ButtonTooltip.vue";

export default {
  name: "ScenarioTypeFilter",

  components: {
    ButtonTooltip,
  },

  props: {
    scenarios: {
      type: Array,
      required: true,
    },
    activeCategories: {
      type: Array,
      required: true,
    },
    filteredScenarios: {
      type: Array,
      required: true,
    },
  },

  computed: {
    examplesCount() {
      return this.scenarios.filter((s) => !s.isPuzzle).length;
    },

    puzzlesCount() {
      return this.scenarios.filter((s) => s.isPuzzle).length;
    },

    classworkCount() {
      return this.scenarios.filter((s) => !s.isHomework).length;
    },

    homeworkCount() {
      return this.scenarios.filter((s) => s.isHomework).length;
    },

    scenarioTypeLabel() {
      // Build label with icons of active categories
      let label = "";
      if (this.activeCategories.includes("examples")) label += "📝";
      if (this.activeCategories.includes("puzzles")) label += "🧩";
      if (this.activeCategories.includes("classwork")) label += "📖";
      if (this.activeCategories.includes("homework")) label += "📚";

      // Add count of filtered scenarios
      label += ` (${this.filteredScenarios.length})`;

      return label;
    },
  },

  methods: {
    toggleFilter(filterType) {
      this.$emit("toggle-filter", filterType);
    },
  },
};
</script>

<style scoped></style>
